import { Component, NgModule, Inject, ViewChild, ViewChildren, Input, OnInit, AfterViewInit, ElementRef, QueryList, PLATFORM_ID, ChangeDetectorRef, ChangeDetectionStrategy, NgZone } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { Page } from '../shared/navigation/pages.model';
import { environment } from 'src/environments/environment';
import { env } from 'process';

@Component({
    templateUrl: 'simple.component.html',
    styleUrls: ['simple.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})

export class SimpleComponent implements OnInit {
    
    public cdn = environment.cdn;
    public pageName = environment.name;
    public pageTitle: string;
    public pageContent: string;
    public gallery: any;
    public children: Page[] = [];


    constructor(@Inject(PLATFORM_ID) private platformId: Object, private ngZone: NgZone, private cdr: ChangeDetectorRef) {
    }
    ngOnInit() {}
}

@NgModule({
    declarations: [SimpleComponent],
    imports: [CommonModule, SharedModule]
})
class SimpleModule { }